import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut, orderId, sku, cud, commune } = useSelector(
    (state) => state.issuesSlice,
  );

  return [
    {
      name: 'commune',
      label: 'Comune',
      disabled: true,
      required: true,
      value: commune,
      hidden: true,
    },
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'orderId',
      label: 'Oc',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'rut',
      label: 'RUT',
      disabled: true,
      required: true,
      value: rut,
      hidden: true,
    },
    {
      name: 'paymentMethod',
      inputAdornment: '',
      label: 'Medio de pago',
      disabled: false,
      required: true,
      inputType: 'select',
    },
    {
      name: 'bank',
      inputAdornment: '',
      label: 'Banco',
      disabled: false,
      required: true,
      inputType: 'select',
    },
    {
      name: 'comment',
      multiline: true,
      rows: 4,
      inputAdornment: '',
      label: 'Escribir comentario',
      textArea: 'Escribir comentario',
      disabled: false,
      required: true,
      helper: '',
    },
  ];
};
